import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Play } from "lucide-react";

const RaulvinsTake = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section ref={ref} className="py-20 md:py-28 bg-[var(--bg-secondary)] relative" data-testid="raulvins-take-section">
      <div className="max-w-5xl mx-auto px-6 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="space-y-8"
        >
          <p className="font-display text-2xl md:text-3xl text-white italic">
            Raulvin's Take
          </p>

          <div className="relative pl-8 border-l-2 border-[var(--accent-violet)]/40">
            <span className="absolute -left-5 top-0 text-6xl text-[var(--accent-violet)]/30 font-display leading-none">"</span>
            <blockquote className="font-display text-2xl md:text-3xl lg:text-4xl text-white/90 italic leading-relaxed">
              The question is no longer what job should I get, but what kind of life do I want to build, and what intelligence will help me stay adaptive as the world changes?
            </blockquote>
          </div>

          <div className="flex items-center justify-between">
            <p className="text-[var(--text-secondary)]">
              — <span className="text-white">Raulvin Coke</span>
            </p>
            <button
              className="flex items-center gap-3 text-[var(--text-secondary)] hover:text-white transition-colors group"
              data-testid="watch-take-btn"
            >
              <span className="w-10 h-10 rounded-full border border-[var(--accent-violet)]/40 flex items-center justify-center group-hover:bg-[var(--accent-violet)]/20 transition-all">
                <Play className="w-4 h-4 text-[var(--accent-violet-light)]" />
              </span>
              <span className="text-sm font-medium">Watch a Short Message From Raulvin</span>
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RaulvinsTake;
